
import { computed, onMounted, ref, watch } from 'vue';
import Button from 'primevue/button';
import Message from 'primevue/message';
import { game } from '../apis/game';
import { GamesList, GameStatusResult, ListByGameCodeResult, ListByGameTypeResult } from '../types/game';
import GameNavbar from '../components/navbar/GameNavbar.vue'

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { showVuePopup } from '../utils/showVuePopup';
import Login from '../popup/Login.vue';
import { useToast } from 'primevue/usetoast';


export default {
	name: 'Lotto',
	components: {
		IconField,
		InputIcon,
		InputText,
		Button,
		Message,
		GameNavbar,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		onMounted(async () => {
			await handleGameStatus();
			await handleProducts(gameType.value);

		});

		const gameType = ref(4);
		const error = ref<string | null>(null);

		const loadingProducts = ref(true);

		const gameState = ref<GameStatusResult>({
			card: false,
			casino: false,
			cock: false,
			esport: false,
			fish: false,
			keno: false,
			lotto: false,
			poker: false,
			slot: false,
			sport: false,
			trade: false,
		});

		const selectedProduct = ref<GamesList>();
		const products = ref<GamesList[]>([]);

		const searchQuery = ref('');

		const productsList = computed(() => {
			return products.value.filter((product) =>
				product.productName?.toLowerCase().includes(searchQuery.value.toLowerCase())
			);
		});

		const handleGameStatus = async () => {
			try {
				const resp = await game.status();

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as GameStatusResult;

				gameState.value = result;
			} catch (err: any) {
				error.value = err.message;
			}
		};

		const handleProducts = async (type: number) => {
			loadingProducts.value = true;
			error.value = null;

			try {
				const payload = { gameType: type, showGames: true };

				const resp = await game.listByType(payload);

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as ListByGameTypeResult;

				products.value = result.gamesList;
				selectedProduct.value = products.value[0] || null;
			} catch (err: any) {
				error.value = err.message;
			} finally {
				loadingProducts.value = false;
			}
		};

		const clickGame = async (code: string) => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login);
				return;
			}

			const found = products.value.find((p) => p.productCode === code);
			if (found) {
				selectedProduct.value = found;

				try {
					const payload = {
						gameType: 4,
						productCode: found.productCode,
						code: code,
						redirect: window.location.origin,
						isMobile: true
					}
					const resp = await game.login(payload);

					if (resp.code !== '0') throw new Error(resp.message)

					window.open(resp?.url, '_blank');
				} catch (err: any) {
					error.value = err.message;
				}
			}
		};

		return {
			auth,
			gameType,
			productsList,
			searchQuery,
			selectedProduct,
			clickGame,
			error,
			loadingProducts,
		};
	},
};
